import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Scalpel"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21.6224 3.87759C20.4343 2.74425 18.5654 2.74425 17.3774 3.87759L0.254883 21.0001H7.19238C8.18503 20.9999 9.13709 20.6061 9.83988 19.9051L21.6224 8.12259C22.1857 7.55988 22.5022 6.79632 22.5022 6.00009C22.5022 5.20386 22.1857 4.44029 21.6224 3.87759ZM9.21733 14.1601L10.7848 12.5926L12.9073 14.7151L11.3398 16.2826L9.21733 14.1601ZM8.78236 18.8401C8.36081 19.2621 7.7889 19.4995 7.19236 19.5001H3.87736L8.15986 15.2176L10.2824 17.3401L8.78236 18.8401ZM20.5573 7.05761L13.9648 13.6576L11.8423 11.5351L18.4423 4.94261C19.0274 4.36102 19.9723 4.36102 20.5573 4.94261C21.1389 5.52766 21.1389 6.47255 20.5573 7.05761Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Scalpel.vue"]]);
